import { render, staticRenderFns } from "./GoalCardActivityPanel.vue?vue&type=template&id=527fdf2b&scoped=true&"
import script from "./GoalCardActivityPanel.vue?vue&type=script&lang=js&"
export * from "./GoalCardActivityPanel.vue?vue&type=script&lang=js&"
import style0 from "./GoalCardActivityPanel.vue?vue&type=style&index=0&id=527fdf2b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527fdf2b",
  null
  
)

export default component.exports